import { darken, getLuminance, lighten } from 'polished';
import { LUMINANCE_THRESHOLD } from 'tabview/consts';

export const getHoverColor = (baseColor: string) => {
  return getLuminance(baseColor) > LUMINANCE_THRESHOLD
    ? darken(0.02, baseColor)
    : lighten(0.08, baseColor);
};
